import { CallGetAPI, CallPostAPI, CreateUrl } from '../../Utils/ApiHelper';
import moment from 'moment'
import {adjustTime } from '../../Utils/AdjustTime'
import { UserSettings } from '../../models/APIUserSettingsModel'
import { APILoggerDetail } from 'models/APILoggerDetail';
import { GraphSettings } from '../../models/GraphTemplateModel'
import { IntlShape } from 'react-intl';
import { NotificationManager } from 'react-notifications';



export interface MNFData {
    calcTimeUTC: Date
    channel: string
    fkCompanyId: number | null
    fkLCLoggerId: number | null
    fkLoggerId: number | null
    id: number
    minValue: number
    minValueTimeStamp: Date
    minValueTimeStampDisplay: Date
    serial: number
    siteId: number | null
    loggerBreakdown: string | null
}

export interface MultiLoggerColumnData {
    day: Date
    [key: string]: number | Date | null | undefined
    average: number | null
    dailyTotal: number
    timeOfReading: Date
}

export interface loggerInfo {
    serial: number
    color: string
}

export interface UserTemplate {
    createdDate: Date
    fkCompanyId: number
    graphSettings: GraphSettings
    serial: number | null
    siteId: number | null
    userId: number | null
}
export interface Breakdown {
    loggerserial: string
    flow: string
}



export const professionalColors = [
    "#2C5F9B", // Deep blue
    "#4CAF50", // Forest green
    "#6A4C93", // Muted purple
    "#F4B740", // Golden yellow
    "#00ACC1", // Teal blue
    "#5D4037", // Dark brown
    "#3F51B5", // Indigo
    "#607D8B", // Blue gray
    "#009688", // Teal green
    "#7CB342", // Light green
    "#1565C0", // Darker blue
    "#8E24AA", // Rich purple
    "#00897B", // Deep teal
    "#546E7A", // Slate
    "#43A047"  // Emerald green
];


export interface APISiteLoggerDetail extends APILoggerDetail {
    IsSiteOutput: boolean
}

export interface AvgStyling {
    color: string
    width: number
    showPoints: boolean
    size: number
}


export interface UserTemplateJSON {
    createdDate: Date
    fkCompanyId: number
    graphSettings: string
    serial: number | null
    siteId: number | null
    userId: number | null
}

export const reloadData = (
    setLoading: (load: boolean) => void,
    serial: number | null,
    startDate: Date,
    endDate: Date,
    setAllValuesZero: (value: boolean) => void,
    loggers: loggerInfo[],
    useCustomColors: boolean,
    setUseCustomColors: (col: boolean) => void,
    setLoggers: (logData: loggerInfo[]) => void,
    setGraphData: (data: MultiLoggerColumnData[]) => void,
    siteId: number | null,
    loggerData: APISiteLoggerDetail[] | null,
    setErrorMessage: (mess: string) => void,
    setOutputLoggers: (out: number[]) => void,
    intl: IntlShape 

): void => {
    setLoading(true)
    let customColor = false
    if (serial) {
        CallGetAPI(CreateUrl(`/api/aquaguard/getmnf?serial=${serial}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`), {})
            .then(async (data: Array<MNFData>) => {
                const sortedData: Array<MultiLoggerColumnData> = []
                if (data.length > 0) {
                    customColor = await checkForCustomColorsAPI(setUseCustomColors)
                    for (let i = 0; i < data.length; i++) {
                        data[i].minValueTimeStampDisplay = moment(adjustTime(moment(data[i].minValueTimeStamp).toDate())).startOf('day')
                        let average = 0
                        if (i > 5) {
                            for (let j = 0; j < 7; j++) {
                                average += data[i - j].minValue
                            }
                            average /= 7
                        }
                        if (data[i].minValue > 0) {

                            setAllValuesZero(false)
                        }
                        sortedData.push({
                            day: data[i].minValueTimeStampDisplay,
                            timeOfReading: moment(adjustTime(data[i].minValueTimeStamp)).toDate(),
                            [`${data[i].serial}`]: parseFloat(data[i].minValue.toFixed(3)),
                            average: i > 5 ? parseFloat(average.toFixed(3)) : null,
                            dailyTotal: data[i].minValue
                        })
                    }
                }

                const loggersData = []
                if (!loggers[0]?.color || !useCustomColors) {
                    loggersData.push({
                        serial: serial, color: professionalColors[0]
                    })

                } else {
                    loggersData.push({ serial: serial, color: professionalColors[0] === loggers[0].color ? professionalColors[0] : loggers[0].color })
                }
                setLoggers(loggersData)
                setGraphData(sortedData)
                setLoading(false)

                if (customColor) {
                    setUseCustomColors(true)
                    handleCustomColorLoad(
                        loggersData,
                        serial,
                        loggers,
                        null,
                        setErrorMessage,
                        setLoggers,
                        intl
                    )
                }
            })
            .catch(err => console.log(err))
    } else if (siteId) {
        CallGetAPI(CreateUrl(`/api/aquaguard/getmnf?siteId=${siteId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`), {})
            .then(async (data: Array<MNFData>) => {
                console.log(data)
                const loggersInSite: Array<loggerInfo> = []
                const outputLoggersTemp: Array<number> = []
                if (loggerData) {
                    customColor = await checkForCustomColorsAPI(setUseCustomColors)
                    loggerData.forEach((logger: number) => {
                        if (logger.isSiteOutput) {
                            outputLoggersTemp.push(logger.serial)
                        }
                        if (!loggersInSite.map(i => i.serial).includes(logger.serial)) {
                            loggersInSite.push({ serial: logger.serial, color: professionalColors[loggersInSite.length] })
                        }
                    })
                }

                const sortedData: Array<MultiLoggerColumnData> = []

                for (let i = 0; i < data.length; i++) {
                    if (!data[i].serial) {
                        if (data[i].minValue > 0) {
                            setAllValuesZero(false)
                        }
                        const dailyInfo: MultiLoggerColumnData = {}
                        let average = 0
                        dailyInfo.day = moment(data[i].minValueTimeStamp).startOf('day').toDate()
                        dailyInfo.timeOfReading = adjustTime(moment(data[i].minValueTimeStamp).toDate())
                        if (data[i].loggerBreakdown) {
                            const breakDown = JSON.parse(data[i].loggerBreakdown)

                            breakDown.forEach((log: Breakdown) => {
                                console.log(log)
                                if (outputLoggersTemp.includes(parseInt(log.loggerserial))) {
                                    dailyInfo[`${log.loggerserial}`] = Number(-parseFloat(log.flow).toFixed(3))
                                } else {
                                    dailyInfo[`${log.loggerserial}`] = Number(parseFloat(log.flow).toFixed(3))
                                }
                            })

                        }

                        if (i > 5) {
                            for (let j = 0; j < 7; j++) {
                                let outputFlow = 0
                                const breakDown = JSON.parse(data[i - j].loggerBreakdown)
                                breakDown.forEach((log: Breakdown) => {
                                    if (outputLoggersTemp.includes(parseInt(log.loggerserial))) {
                                        outputFlow += parseFloat(log.flow)
                                    }
                                })
                                average += data[i - j].minValue - (outputFlow * 2)
                            }
                            average /= 7
                            dailyInfo.average = parseFloat(average.toFixed(3))
                        } else {
                            dailyInfo.average = null
                        }


                        sortedData.push(dailyInfo)
                    }
                }
                console.log(sortedData)
                setOutputLoggers(outputLoggersTemp)
                setLoggers(loggersInSite)
                setGraphData(sortedData)
                setLoading(false)
                if (customColor) {
                    setUseCustomColors(true)
                    handleCustomColorLoad(
                        loggersInSite,
                        null,
                        loggers,
                        siteId,
                        setErrorMessage,
                        setLoggers,
                        intl
                    )
                }
            })
            .catch(err => console.log(err))
    }

}

const checkForCustomColorsAPI = async (setUseCustomColors: (use: boolean) => void): Promise<boolean> => {
    CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
    try {
        const data: UserSettings[] = await CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF`), {})
        if (data.length > 0) {

            for (const userSetting of data) {
                if (userSetting.settingsKey === 'Custom Colours' && userSetting.settingsValue === 'true') {
                    setUseCustomColors(true)

                    return true
                }
            }
        }
        return false

    } catch (err) {
        console.error(err)
        return false
    }
} 


 export const handleCustomColorLoad = (
    loggersDataProps: Array<APISiteLoggerDetail> | null | undefined,
    serial: number | null,
    loggers: loggerInfo[],
    siteId: number | null,
    setErrorMessage: (msg: string) => void,
    setLoggers: (data: loggerInfo[]) => void,
    intl: IntlShape
): void => {
    CallGetAPI(CreateUrl(`/api/aquaguard/graphTemplate?CompanyId=${sessionStorage.getItem('companyId')}`), {})
        .then(data => {
            let userId
            if (sessionStorage.getItem('userId')) {
                userId = sessionStorage.getItem('userId')
            }
            const extractedData = data.map((item: UserTemplateJSON) => {
                item.graphSettings = JSON.parse(item.graphSettings)

                return item
            })
            let userTemplate: UserTemplate[] | [] = []
            if (serial && userId) {
                userTemplate = extractedData.filter((template: UserTemplate) => serial === template.serial).filter((template: UserTemplate) => {
                    return template.userId === parseInt(userId)
                })
            } else if (!serial && userId) {

                userTemplate = extractedData.filter((template: UserTemplate) => loggersDataProps?.map(prop => prop.serial).includes(template.serial)).filter((template: UserTemplate) => {
                    return template.userId === parseInt(userId)
                })
            }

            const companyTemplate: UserTemplate[] = extractedData.filter((template: UserTemplate) => {
                return !template.serial && !template.userId
            })

            const userDefaultTemplate: UserTemplate[] = extractedData.filter((template: UserTemplate) => {
                return !template.serial && template.userId
            })


            let loggersData = loggersDataProps ? loggersDataProps : loggers

            if (!siteId) {
                if (userTemplate.length > 0) {
                    loggersData = loggersData.map(logger => {
                        userTemplate.forEach((template: UserTemplate) => {

                            if (template.serial === logger.serial) {
                                logger.color = template.graphSettings.flowAColor
                            }
                        })
                        return logger
                    })
                } else if (userDefaultTemplate.length > 0) {
                    loggersData = loggersData.map(logger => {
                        logger.color = userDefaultTemplate[0].graphSettings.flowAColor
                        return logger
                    })
                } else if (companyTemplate.length > 0) {
                    loggersData = loggersData.map(logger => {
                        logger.color = companyTemplate[0].graphSettings.flowAColor
                        return logger
                    })
                } else {
                    setErrorMessage(intl.formatMessage({ id: "No Settings Found" }))
                }

            } else {
                if (userTemplate.length > 0) {
                    if (userTemplate.length === loggersData.length) {
                        loggersData.forEach(log => {
                            const color = userTemplate.filter(temp => temp.serial === log.serial)[0].graphSettings.flowAColor
                            log.color = color
                        })
                    } else {
                        // if some logger have custom colours but other dont we need to check down the higherarcy of settings
                        if (userDefaultTemplate.length > 0) {
                            loggersData.forEach(log => {
                                const color = userTemplate.filter(temp => temp.serial === log.serial)[0].graphSettings.flowAColor
                                if (color) {
                                    log.color = color
                                } else {
                                    log.color = userDefaultTemplate[0].graphSettings.flowAColor
                                }
                            })
                        } else if (companyTemplate.length > 0) {
                            loggersData.forEach(log => {
                                const color = userTemplate.filter(temp => temp.serial === log.serial)[0].graphSettings.flowAColor
                                if (color) {
                                    log.color = color
                                } else {
                                    log.color = companyTemplate[0].graphSettings.flowAColor
                                }
                            })
                        }
                    }
                } else if (userDefaultTemplate.length > 0) {
                    loggersData = loggersData.map(logger => {
                        logger.color = userDefaultTemplate[0].graphSettings.flowAColor
                        return logger
                    })
                } else if (companyTemplate.length > 0) {
                    loggersData = loggersData.map(logger => {
                        logger.color = companyTemplate[0].graphSettings.flowAColor
                        return logger
                    })
                } else {
                    setErrorMessage("No Settings Found")
                }
            }





            //loggersUnitsAndValues.forEach(unit => unit.alarms = [])
            setLoggers(loggersData)
        })
        .catch((error) => {
            console.error(error);
            createErrorNotification(intl)
        });


} 

const createErrorNotification = (intl:IntlShape): void => {
    NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }));
};


export const handleCustomColorClick = (
    useCustomColors: boolean,
    setUseCustomColors: (col: boolean) => void,
    loggers: loggerInfo[],
    setLoggers: (setLog: loggerInfo[]) => void,
    serial: number,
    siteId: number,
    setErrorMessage: (mess: string) => void,
    intl: IntlShape


): void => {
    CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=MNF&key=Custom%20Colours&value=${!useCustomColors}`), {})
        .catch(err => {
            console.error(err)
            createErrorNotification(intl)
        })
    if (useCustomColors) {
        setUseCustomColors(false)

        const loggersData = loggers
        loggersData.forEach((logger, idx) => {
            logger.color = professionalColors[idx]
        })
        setLoggers(loggersData)

    } else {
        setUseCustomColors(true)
        handleCustomColorLoad(
            undefined,
            serial,
            loggers,
            siteId,
            setErrorMessage,
            setLoggers,
            intl
        )
    }
}






